import axios, { HttpStatusCode } from "axios";
import {
  FLIGHT_SEARCH_FILTER,
  CLEAR_SEARCH_DATA,
  FILTERED_FLIGHT_LIST,
  FILTER_TIMES,
  FLIGHT_LIST,
  COUNTRY_LIST,
  FILTERED_FILTER_ITEMS,
  HOLDED_FLIGHT_ITEM,
  HOLDED_FLIGHT_RESPONSE,
  FLIGHT_SEARCH_FORM,
  IS_FLIGHT_SEARCHING,
  DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM,
} from "../reducers/types";
import { toast } from "@/components/ui/use-toast";
import { defaultHeader } from "../constants/defaultItems";
export const domesticAirports = [
  { "AirportName": "TIA", "IATAcode": "KTM", "AirportCity": "Kathmandu", "Country": "Nepal" },
  { "AirportName": "Bharatpur Airport", "IATAcode": "BHR", "AirportCity": "Bharatpur", "Country": "Nepal" },
  { "AirportName": "Bhairahawa Airport", "IATAcode": "BWA", "AirportCity": "Bhairahawa", "Country": "Nepal" },
  { "AirportName": "Bhadrapur Airport", "IATAcode": "BDP", "AirportCity": "Bhadrapur", "Country": "Nepal" },
  { "AirportName": "Dang Airport", "IATAcode": "DNP", "AirportCity": "Dang", "Country": "Nepal" },
  { "AirportName": "Dolpa Airport", "IATAcode": "DOP", "AirportCity": "Dolpa", "Country": "Nepal" },
  { "AirportName": "Janakpur Airport", "IATAcode": "JKR", "AirportCity": "Janakpur", "Country": "Nepal" },
  { "AirportName": "Jomsom Airport", "IATAcode": "JMO", "AirportCity": "Jomsom", "Country": "Nepal" },
  { "AirportName": "Jumla Airport", "IATAcode": "JUM", "AirportCity": "Jumla", "Country": "Nepal" },
  { "AirportName": "Lukla Airport", "IATAcode": "LUA", "AirportCity": "Lukla", "Country": "Nepal" },
  { "AirportName": "Pokhara Airport", "IATAcode": "PKR", "AirportCity": "Pokhara", "Country": "Nepal" },
  { "AirportName": "Rajbiraj Airport", "IATAcode": "RJB", "AirportCity": "Rajbiraj", "Country": "Nepal" },
  { "AirportName": "Ramechhap Airport", "IATAcode": "RHP", "AirportCity": "Ramechhap", "Country": "Nepal" },
  { "AirportName": "Simara Airport", "IATAcode": "SIF", "AirportCity": "Simara", "Country": "Nepal" },
  { "AirportName": "Simikot Airport", "IATAcode": "IMK", "AirportCity": "Simikot", "Country": "Nepal" },
  { "AirportName": "Tumlingtar Airport", "IATAcode": "TMI", "AirportCity": "Tumlingtar", "Country": "Nepal" },
  { "AirportName": "Bajura Airport", "IATAcode": "BJU", "AirportCity": "Bajura", "Country": "Nepal" },
  { "AirportName": "Nepalgunj Airport", "IATAcode": "KEP", "AirportCity": "Nepalgunj", "Country": "Nepal" },
  { "AirportName": "Varanasi", "IATAcode": "VNS", "AirportCity": "Uttar Pradesh", "Country": "India" },
  { "AirportName": "Kolkata", "IATAcode": "CCU", "AirportCity": "West Bengal", "Country": "India" },
];
export const setFlightFilters = (payload, callback) => (dispatch) => {
  dispatch({ type: FILTERED_FILTER_ITEMS, payload: payload });
  dispatch({
    type: FILTERED_FLIGHT_LIST,
    payload: [],
  });
  callback && callback(payload);
};
export const filterFlightList = (data, callback) => (dispatch) => {
  window.scrollTo(0, 0);
  dispatch({
    type: FILTERED_FLIGHT_LIST,
    payload: data,
  });
};
export const getAvailableFlights = (filteredData, isDomestic, callback) => (dispatch) => {
  dispatch({
    type: IS_FLIGHT_SEARCHING,
    payload: true
  })
  axios
    .post(`/api/${isDomestic ? "DomesticFlight/GetAvailableFlights" : "IntFlight/GetAvailableFlight"}`, filteredData, defaultHeader)
    .then(function (resp) {
      if (isDomestic) {
        dispatch(
          {
            type: FLIGHT_LIST,
            payload: resp.data
          })
        dispatch(
          {
            type: IS_FLIGHT_SEARCHING,
            payload: false
          })
      }
      else {
        if (resp.data.IsSuccess) {
          dispatch({ type: FLIGHT_LIST, payload: resp.data.Results.length > 0 ? resp.data.Results : [] });
          dispatch({ type: FILTER_TIMES, payload: resp.data.FilterTimes });

          callback && callback(resp.data);
          dispatch({
            type: IS_FLIGHT_SEARCHING,
            payload: false
          })
        } else {
          callback && callback();
        }
      }
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};
export const clearFilterTimes = (callback) => (dispatch) => {
  dispatch({
    type: FILTER_TIMES,
    payload: [],
  });
};
export const checkTransitInfo = (payload, callback) => (dispatch) => {
  axios
    .post("/api/IntFlight/CheckTransitInfo", payload, defaultHeader)
    .then(function (resp) {
      if (resp) {
        callback && callback(resp);
      }
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};
export const holdFlight = (payload, callback) => (dispatch) => {
  window.scrollTo(0, 0);
  axios
    .post("/api/IntFlight/HoldFlight", payload, defaultHeader)
    .then(function (resp) {
      console.log("response from hold flight ", resp);
      if (resp.data.IsSuccess) {
        dispatch({
          type: HOLDED_FLIGHT_RESPONSE,
          payload: resp.data.Result,
        });
        localStorage.setItem("transId", resp.data.Result.SessionID);
      }
      callback && callback(resp.data.Result);
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};
export const bookFlight = (payload, callback) => (dispatch) => {
  axios
    .post("/api/IntFlight/BookFlight", payload, defaultHeader)
    .then(function (resp) {
      if (resp) {
        // dispatch({
        //   type: HOLDED_FLIGHT_RESPONSE,
        //   payload: resp.data
        // })
        // localStorage.setItem("transId", resp.data.TranID);
        callback && callback(resp.data);
      }
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};
export const holdHoldedFlightItem = (payload, returnFlight = null) => (dispatch) => {
  dispatch({
    type: HOLDED_FLIGHT_ITEM,
    payload: payload,
  });
  if (returnFlight) {
    dispatch({
      type: DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM,
      payload: returnFlight,
    })
  }
};
export const getSearchFilters = (callback) => (dispatch) => {
  axios
    .get("/api/IntFlight/GetSearchFilters", defaultHeader)
    .then(function (resp) {
      if (resp.status == 200) {
        dispatch({ type: FLIGHT_SEARCH_FILTER, payload: resp.data });
        callback && callback({ ...resp.data, Airports: [...resp.data.Airports, ...domesticAirports] });
      }
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};

export const setSearchPayload = (payload) => (dispatch) => {
  dispatch({
    type: FLIGHT_SEARCH_FORM,
    payload: payload,
  });
};

export const getMyBookings = (callback) => (dispatch) => {
  axios.get("/api/IntFlight/GetMyBooking", defaultHeader).then((resp) => {
    callback && callback(resp.data.Results);
  });
};

export const clearSearchResults = () => (dispatch) => {
  dispatch({ type: FLIGHT_LIST, payload: [] });
  dispatch({ type: FILTER_TIMES, payload: [] });
  dispatch({ type: FILTERED_FLIGHT_LIST, payload: [] });
};

export const GetFareRule = (payload, callback) => (disaptch) => {
  var payloadParam = new URLSearchParams(payload).toString();
  axios
    .get("/api/IntFlight/GetFareRule?" + payloadParam, defaultHeader)
    .then((resp) => {
      if (resp.status == HttpStatusCode.Ok) {
        callback && callback(resp.data);
      }
    });
};

export const UpdateBookingPaymentInfo = (payload, callback) => (dispatch) => {
  axios.post("/api/IntFlight/UpdateBookingPaymentInfo", payload, defaultHeader).then((resp) => {
    if (resp.status == HttpStatusCode.Ok) {
      callback && callback(resp.data);
    }
  })
}
export const revalidateItinerary = (payload, callback) => (dispatch) => {
  window.scrollTo(0, 0);
  axios
    .post("/api/IntFlight/RevalidateItinerary", payload, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        dispatch({
          type: HOLDED_FLIGHT_RESPONSE,
          payload: resp.data.Result,
        });
        localStorage.setItem("transId", resp.data.Result.SessionID);
      }
      callback && callback(resp.data.Result);
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};

export const GetStructuredFareRule = (payload, callback) => (dispatch) => {
  axios
    .post("/api/IntFlight/GetStructuredFareRule", payload, defaultHeader)
    .then((resp) => {
      if (resp.status == HttpStatusCode.Ok) {
        callback && callback(resp.data);
      }
    })
    .catch(function (error) {
      console.log("Error in GetStructuredFareRule", error);
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};